import { isNumber } from '@xemplo/common-util';

export function parseWidth(width?: string | number): string {
  if (!width) return '100%';

  return isNumber(width) ? `${width}px` : width;
}

export function parseWidthCssVar(width?: string | number) {
  const parsed = parseWidth(width);
  return { '--input-width': parsed } as React.CSSProperties;
}
